import { Button } from '../../../../../../../../libs/components/components';
import { AppRoute } from '../../../../../../../../libs/enums/enums';
import ArrowRightIcon from '../../../../../../../../../public/svg/arrow-right.svg';
import ShopperManCircle from '../../../../../../../../../public/images/Shopper_Man_Circle.webp';
import ExportedImage from 'next-image-export-optimizer';

const GetHealingHelpBanner = () => {
  return (
    <div className="bg-ogn-blue absolute lg:bottom-20 bottom-16 left-1/2 -translate-x-1/2 flex rounded-[8px]">
      <div className="flex items-center lg:justify-center justify-between gap-x-2 lg:gap-x-10 px-2 lg:px-10">
        <div className="flex-shrink-0 w-[56px] h-[69px] lg:w-[216px] lg:h-[264px] -mt-8 lg:-mt-24 bottom-0 left-0 relative">
          <ExportedImage
            fill
            src={ShopperManCircle}
            alt="Shopper Man Circle"
            className="object-cover"
          />
        </div>
        <div className="flex flex-col text-white pb-2 lg:pb-10">
          <h3 className="text-[6px] lg:text-[24px] font-bold leading-[12px] lg:leading-[32px] mt-2 lg:mt-8">
            Get Help for Healing
          </h3>
          <p className="text-[4px] lg:text-[16px]">
            Get email updates, discussion guides, and more
          </p>
          <Button
            to={AppRoute.HEALING_NAVIGATOR}
            variant="white"
            className="px-2 self-start mt-2 lg:mt-4 flex items-center gap-x-1 lg:gap-x-2 py-1 lg:py-2 text-[5px]"
          >
            <span className="text-nowrap">Start Healing Now</span>{' '}
            <ArrowRightIcon className="w-[7px] h-[7px] lg:w-[16px] lg:h-[16px]" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export { GetHealingHelpBanner };
